import { html, nothing, render } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";
import { data } from "@escapio/shared/state/payload";
import { RandomSelector } from "@escapio/portal/components/hotel-list/RandomSelector";
import { onChangeCurrency, travelData } from "@escapio/portal/state/travelData";
import { RESULT_AD_BANNER } from "@escapio/shared/components/picture-sizes";
import "@escapio/portal/components/tracker/ImpressionInteractionTracker";

function parseSettings() {
	try {
		return JSON.parse(document.getElementById("esc-result-ads").textContent);
	} catch {
		return null;
	}
}

customElements.define(
	"esc-result-ads-banner",
	class extends HTMLElement {
		constructor() {
			super();
			this.resultAdSelector = new RandomSelector("last_seen_result_ad")
				.setCandidates(parseSettings())
				.fulfillsCondition(
					resultAd =>
						resultAd.currency_restrictions?.length < 1 ||
						resultAd.currency_restrictions.includes(travelData.currency),
				);

			this.selectAd();
			this.eventCallback = () => {
				this.selectAd();
				this.render();
			};
			onChangeCurrency(this.eventCallback);
		}

		connectedCallback() {
			document.addEventListener("hotelListPaginated", this.eventCallback);
			this.render();
		}

		selectAd() {
			this.resultAd = this.resultAdSelector.select();
		}

		render() {
			render(
				this.resultAd
					? html`<esc-impression-interaction-tracker
							content-name="Result Ad"
							content-piece="${this.resultAd.id} | ${data.trackingId}"
							content-target=${this.resultAd.link_url}
						>
							<a
								class="hotel-list-item ads-banner"
								href=${this.resultAd.link_url}
								target="_blank"
								rel="nofollow noopener"
							>
								${this.resultAd.is_ad
									? html`<div class="ads-banner-hint">
											${translate("basic_advertisement")}
										</div>`
									: nothing}
								<esc-picture
									class="ads-banner-img"
									alt=${this.resultAd.title}
									sizes-key="${RESULT_AD_BANNER}"
									filename=${this.resultAd.image}
								>
								</esc-picture>
								<div class="ads-banner-title">${this.resultAd.title}</div>
								<div class="ads-banner-description">${this.resultAd.text}</div>
								<button class="action-button ads-banner-button">
									<span class="button-text">${this.resultAd.link_title}</span>
								</button>
							</a>
						</esc-impression-interaction-tracker>`
					: nothing,
				this,
			);
		}

		disconnectedCallback() {
			document.removeEventListener("hotelListPaginated", this.eventCallback);
		}
	},
);
